import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import {
    chain,
    SetShipToForEditing,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseOneTimeAddress";

export type HandlerType = Parameters<typeof SetShipToForEditing>[0];

addToChainAfter(chain, SetShipToForEditing, SetDefaultCountry);

function SetDefaultCountry(props: HandlerType) {
    const countries = getCurrentCountries(props.getState());
    if (!countries) {
        throw new Error("There were no countries loaded yet");
    }

    const defaultCountryId = getSettingsCollection(props.getState()).accountSettings?.defaultCountryId ?? "";

    const defaultCountry = countries.find(country => country.id === defaultCountryId);

    if (!props.shipToForEditing.country && !!defaultCountry) {
        props.shipToForEditing.country = defaultCountry;
    }
}
